// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__23x4u","title":"ClientInsurance_title__teCTJ","itemText":"ClientInsurance_itemText__2dHBU"};